const actions = {
  SET_MENU_STATE: 'SET_MENU_STATE',
  GET_MENU_DATA: 'SET_MENU_STATE',
}

export default actions
